// @flow
import type { Subscription } from 'digicel-kaizen-library';

export type Action =
  | {|
      type: 'SELECT_SUBSCRIPTION',
      payload: {|
        subscription: ?Subscription,
        skipSavingAsFirstSubscription: boolean,
      |},
    |}
  | {|
      type: 'TOUCH_PLAN_FRAME',
    |}
  | {|
      type: 'SET_HAS_REFRESHED_AT_LEAST_ONCE',
    |}
  | {|
      type: 'SET_CURRENT_SUBSCRIPTION',
      subscription: Subscription,
    |}
  | {|
      type: 'SWAP_BACKUP_AND_CURRENT_SUBSCRIPTION_OUID',
    |};

export const selectSubscription = (
  subscription: ?Subscription,
  skipSavingAsFirstSubscription: boolean = false
): Action => ({
  type: 'SELECT_SUBSCRIPTION',
  payload: { subscription, skipSavingAsFirstSubscription },
});

export const fetchDashboardData = (forceRefresh: ?boolean) => ({
  type: 'FETCH_DASHBOARD_DATA',
  payload: {
    forceRefresh,
  },
});

export const setHasRefreshedAtLeastOnce = () => ({
  type: 'SET_HAS_REFRESHED_AT_LEAST_ONCE',
});

export const fetchRoamingBundles = () => ({
  type: 'FETCH_ROAMING_BUNDLES',
});

export const touchPlanFrame = (): Action => ({
  type: 'TOUCH_PLAN_FRAME',
});

export const swapBackupAndCurrentSubscriptionOuid = (): Action => ({
  type: 'SWAP_BACKUP_AND_CURRENT_SUBSCRIPTION_OUID',
});
